import UsersBaseController from '../common/users.base.controller'
import AppConstants from '../../../config/app.constants';

class UsersCreateController extends UsersBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, UsersService, Modal, $translate, UserService, BranchService, $q, SetupService,
				$scope, BranchFundingSourceService, UserBranchFundingSourceService, TimezoneList, CustomerService,
				CommonLayoutService, LocationZoneService, AtmMakesService, Configs) {

		super(Auth, $state, User, UsersService, Modal, $translate)
		this.Configs = Configs
		this.UserService = UserService
		this.BranchService = BranchService
		this.SetupService = SetupService
		this.CustomerService = CustomerService;
		this.$q = $q
		this.$scope = $scope;
		this.BranchFundingSourceService = BranchFundingSourceService;
		this.UserBranchFundingSourceService = UserBranchFundingSourceService;
		this.TimezoneList = TimezoneList;
		this.CommonLayoutService = CommonLayoutService;
		this.LocationZoneService = LocationZoneService;
		this.AtmMakesService = AtmMakesService;
		this.defaultModel = {
			firstName: '',
			lastName: '',
			email: '',
			supervisor: false,
			languageId: 'E',
			password: '',
			branchId: null,
			downloadToHHT: false,
			isWebUser: true,
			// kabaKeyId: '',
			// SGKeyId: '',
			defaultAppView: 'List',
			hhtPassword: null,
			phone: null,
			// routeKeyId: '',
			// tecnoDevId: '',
			// OTCCompanyName: null,
			loggedInUser: User.getUser().branchId,
			serviceUser: false,
			timezone: null,
			customerUser: false,
			autoCheckIn: false,
			autoCheckOut: false,
			sameForAll: true,
			payrollId: null,
			limitToServiceZone: false,
			rejectTickets: false,
			shipmentTransfer: false,
			selfAssignServiceTicket: false,
			userAssignServiceTicket: false,
			addActions: false,
			createTickets: false,
			serviceLevel: null,
			userOrigin: null,
			address: null,
			city: null,
			state: null,
			zip: null,
			country: null,
			isNonUSLocation: false,
			lat: null,
			long: null,
			make: [],
			schedule: {}
		}

		this.scheduleDays = [
			{ key: 'Mon', label: 'Monday', shortLabel: 'Monday', startKey: 'startTimeMon', endKey: 'endTimeMon', active: false },
			{ key: 'Tue', label: 'Tuesday', shortLabel: 'Tuesday', startKey: 'startTimeTue', endKey: 'endTimeTue', active: false },
			{ key: 'Wed', label: 'Wednesday', shortLabel: 'Wednesday', startKey: 'startTimeWed', endKey: 'endTimeWed', active: false },
			{ key: 'Thu', label: 'Thursday', shortLabel: 'Thursday', startKey: 'startTimeThu', endKey: 'endTimeThu', active: false },
			{ key: 'Fri', label: 'Friday', shortLabel: 'Friday', startKey: 'startTimeFri', endKey: 'endTimeFri', active: false },
			{ key: 'Sat', label: 'Saturday', shortLabel: 'Saturday', startKey: 'startTimeSat', endKey: 'endTimeSat', active: false },
			{ key: 'Sun', label: 'Sunday', shortLabel: 'Sunday', startKey: 'startTimeSun', endKey: 'endTimeSun', active: false },
			{ key: 'Holiday', label: 'Holiday', shortLabel: 'Holiday', startKey: 'startTimeHoliday', endKey: 'endTimeHoliday', active: false }
		];
		this.scheduleErrors = {};

		this.serviceLevelList = [
			{ label: '(None)', value: null },
			{ label: 'FLM', value: 'FLM' },
			{ label: 'SLM', value: 'SLM' }
		];

		this.userOriginList = [
			{ label: '(None)', value: null },
			{ label: 'Branch', value: 'BRANCH' },
			{ label: 'Vehicle', value: 'VEHICLE' },
			{ label: 'User', value: 'USER' }
		];
		this.atmMakesList = [];

		this.defaultAppView = [
			{
				label: 'List View',
				value: 'List'
			},
			{
				label: 'All Map View',
				value: 'All'
			},
			{
				label: 'Next Map View',
				value: 'Next'
			},
			{
				label: 'Next 3 Map View',
				value: 'Next3'
			}
		]

		this.OTCCompanyNameList = [];
		this.branch = []
		this.language = [{
			value: 'E',
			label: "English"
		},
		// {
		// 	value: 'F',
		// 	label: 'French'
		// }
		{
			value: 'S',
			label: 'Spanish'
		}
		]
		this.cnfPassword = ''
		this.branches = [];
		this.serviceZoneData = [];
		this.permissions = this.Auth.permission()
		this.permissionsToAssign = {};
		this.localLang = {
			selectAll: this.$translate.instant('common.selectall'),
			selectNone: this.$translate.instant('common.selectnone'),
			reset: this.$translate.instant('shipmentBatch.reset'),
			search: this.$translate.instant('common.search'),
			nothingSelected: this.$translate.instant('common.noneselected'),         //default-label is deprecated and replaced with this.
		}
		this.model = angular.copy(this.defaultModel);
		this.OTCKeys = {};
		this.company = {};
		this.timezoneList = this.TimezoneList.getTimezoneList();
		this.countStationList = [];
		this.customerList = [];
		this.totalCustomer = 0;
		// this.lockSystem = [
		// 	{
		// 		label: 'KABA FLM',
		// 		value: 'kabaKeyId'
		// 	},
		// 	{
		// 		label: 'KABA Route',
		// 		value: 'routeKeyId'
		// 	},
		// 	{
		// 		label: 'S&G',
		// 		value: 'SGKeyId'
		// 	},
		// 	{
		// 		label: 'Witz',
		// 		value: 'witzKeyId'
		// 	}
		// ];
	}

	$onInit() {
		this.Configs.getConfigs().then((data) => {
			this.googleMapConfig = data.googleMap;
			this.apiKey = '//maps.google.com/maps/api/js?key=' + this.googleMapConfig.key + '&libraries=places';
			setTimeout(() => {
				this.render = true;
			}, 100);
		});

		this.$q.all([
			this.BranchService.all(null, 0, 1000),
			this.SetupService.all(null, 0, 1000),
			this.SetupService.get(this.model.loggedInUser),
		])
			.then((data) => {
				this.OTCCompanies = data[2].companies;
				this.allSetup = data[1].results;
				const branchesWithExistingSetupRecord = data[1].results.map((setupRecord) => {
					return setupRecord.branchId;
				});
				this.branches = data[0].results
					.filter((branch) => branchesWithExistingSetupRecord.includes(branch.id));

				this.branches.filter((branch) => {
					return branch.id === this.model.branch;
				})
					.map((branch) => {
						branch.ticked = true;
						return branch;
					});
			})
			.then(() => {
				this.setOtcKeys();
				this.OTCCompanyMap();
				this.getCustomer('', 0);
				this.validateAutoChekInChekOut();
				this.loadAtmMakes();
			})
			.catch((err) => {

			})
	}

	toggle(language) {
		this.model.languageId = language.value
	}

	format(key, parentKey) {
		if (parentKey === 'branch_mgmt_orders' && key === 'all') {
			return this.$translate.instant('common.View');
		}
		if (typeof (key) == 'string') {
			key = key.replace('_', '-');
			key = (key !== 'assign' && key !== 'export') ? key.charAt(0).toUpperCase() + key.slice(1) : key;
			key = this.$translate.instant('common.' + key);
		}
		return key;
	}

	togglePerm(key, parentKey) {
		if (parentKey === 'cash_activity' && !this.hasPerm(key, parentKey)) {
			const otherKey = key === 'customer' ? 'funding_source' : 'customer';
			if (this.hasPerm(otherKey, parentKey)) {
				this.permissionsToAssign[parentKey] = this.permissionsToAssign[parentKey].filter(k => k !== otherKey);
			}
		}

		const permissionObj = this.permissionsToAssign[parentKey];

		if (this.hasPerm(key, parentKey)) {
			this.permissionsToAssign[parentKey] = permissionObj.filter(p => p !== key);
			const nextPermObj = this.permissionsToAssign[parentKey];

			const activePerms = nextPermObj.filter(p => p !== 'default_redirect');
			if (activePerms.length === 0) {
				const hadRedirect = nextPermObj.includes('default_redirect');
				delete this.permissionsToAssign[parentKey];
				if (hadRedirect) {
					const parentCategory = this.getParentCategoryKey(parentKey);
					if (parentCategory) {
						if (!this.permissionsToAssign[parentCategory]) {
							this.permissionsToAssign[parentCategory] = [];
						}
						if (!this.permissionsToAssign[parentCategory].includes('default_redirect')) {
							this.permissionsToAssign[parentCategory] = [...this.permissionsToAssign[parentCategory], 'default_redirect'];
						}
					}
				}
			}

			if (!nextPermObj.length || activePerms.length === 0) {
				if (parentKey == 'setting') {
					const settingChild = this.permissions.setting.child;
					const resources = Object.keys(settingChild);
					resources.map((resource) => {
						if (this.model.customerUser && this.customerPermissions.indexOf(resource) < 0) return
						delete this.permissionsToAssign[resource];
					})
				} else if (parentKey == 'branch_mgmt') {
					const branchMgmtChild = this.permissions.branch_mgmt.child;
					const resources = Object.keys(branchMgmtChild);
					resources.forEach((resource) => {
						if (this.model.customerUser && this.customerPermissions.indexOf(resource) < 0) return
						delete this.permissionsToAssign[resource];
					})
				} else if(parentKey == 'branch_mgmt_billing_approval'){
					const branchMgmtBillChild = this.permissions.branch_mgmt.child.branch_mgmt_billing_approval.child;
					const resources = Object.keys(branchMgmtBillChild);
					resources.forEach((resource) => {
						if (this.model.customerUser && this.customerPermissions.indexOf(resource) < 0) return
						delete this.permissionsToAssign[resource];
					})
				} else if(parentKey == 'tnt_billing_fuel_surcharges'){
					const tntBillingFuelsurchargeChild = this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges.child;
					const resources = Object.keys(tntBillingFuelsurchargeChild);
					resources.forEach((resource) => {
						if (this.model.customerUser && this.customerPermissions.indexOf(resource) < 0) return
						delete this.permissionsToAssign[resource];
					})
				} else if (['tnt_billing', 'tnt_control', 'reporting', 'order_packing', 'bulk_transfer'].indexOf(parentKey) >= 0)  {
					let child = this.permissions[parentKey].child;
					const resources = Object.keys(child);
					resources.forEach((resource) => {
						if (this.model.customerUser && this.customerPermissions.indexOf(resource) < 0) return
						delete  this.permissionsToAssign[resource]
					})
				}
				delete this.permissionsToAssign[parentKey];
			}
		}
		else {
			if (permissionObj) {
				permissionObj.push(key);
			} else {
				this.permissionsToAssign[parentKey] = [key];
				
				// if (parentKey == 'setting') {
				// 	const settingChild = this.permissions.setting.child;
				// 	const resources = Object.keys(settingChild);
				// 	resources.map((resource) => {
				// 		if (resource == 'setting-log')
				// 			this.permissionsToAssign[resource] = ["view"];
				// 		else if (resource == 'setting-location')
				// 			this.permissionsToAssign[resource] = ["edit", "delete", "view", "create", "importLocations"];
				// 		else
				// 			this.permissionsToAssign[resource] = ["edit", "delete", "view", "create"];
				// 	})
				// } else 
				if (parentKey == 'branch_mgmt') {
					const branchMgmtChild = this.permissions.branch_mgmt.child;
					const resources = Object.keys(branchMgmtChild);
					resources.forEach((resource) => {
						if (this.model.customerUser && this.customerPermissions.indexOf(resource) < 0) return;
						this.permissionsToAssign[resource] = ["all"];
					})
					
				}else if(parentKey == 'branch_mgmt_billing_approval'){
					const branchMgmtBillChild = this.permissions.branch_mgmt.child.branch_mgmt_billing_approval.child;
					const resources = Object.keys(branchMgmtBillChild);
					resources.forEach((resource) => {
						if (this.model.customerUser && this.customerPermissions.indexOf(resource) < 0) return;
						this.permissionsToAssign[resource] = ["allow"];
					})
				}else if(parentKey == 'tnt_billing_fuel_surcharges'){
					const tntBillingFuelsurchargeChild = this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges.child;
					let childPermisions = [];
					if(tntBillingFuelsurchargeChild['edit']) childPermisions.push('edit')
					if(tntBillingFuelsurchargeChild['view']) childPermisions.push('view')
					if(tntBillingFuelsurchargeChild['create']) childPermisions.push('create')

					const resources = Object.keys(tntBillingFuelsurchargeChild);
					resources.forEach((resource) => {
						if (this.model.customerUser && this.customerPermissions.indexOf(resource) < 0) return;
						this.permissionsToAssign[resource] = childPermisions//Object.keys(childPermission[resource].permission);
					})
				} else if (['setting', 'tnt_billing', 'tnt_control', 'reporting', 'order_packing', 'bulk_transfer'].indexOf(parentKey) >= 0) {
					let child = this.permissions[parentKey].child;
					const resources = Object.keys(child);
					resources.forEach((resource) => {
						if (this.model.customerUser && this.customerPermissions.indexOf(resource) < 0) return;
						if (this.model.customerUser && resource == 'setting-location') {
							this.permissionsToAssign[resource] = [ "view", "edit"]
						} else {
							this.permissionsToAssign[resource] = Object.keys(child[resource].permission).filter(p => p !== 'default_redirect')
						}
					})
				}
			}
		}

		this.cleanupOrphanedDefaultRedirects();
	}

	allowSettings(key, parentKey) {
		this.permissionsToAssign['setting'] = ["all"];
	}

	hasPerm(key, parentKey) {
		const permissionObj = this.permissionsToAssign[parentKey];

		if (permissionObj) {
			return permissionObj.includes(key);
		}
		else {
			return false;
		}
	}

	findResourceNode(resource) {
		if (this.permissions[resource]) return this.permissions[resource];
		for (const topVal of Object.values(this.permissions)) {
			if (topVal.child && topVal.child[resource]) return topVal.child[resource];
			if (topVal.child) {
				for (const childVal of Object.values(topVal.child)) {
					if (childVal.child && childVal.child[resource]) return childVal.child[resource];
				}
			}
		}
		return null;
	}

	hasAnyPerm(resource) {
		const permissionObj = this.permissionsToAssign[resource];
		if (Array.isArray(permissionObj) && permissionObj.some(p => p !== 'default_redirect')) {
			return true;
		}
		const node = this.findResourceNode(resource);
		if (node && node.child) {
			return Object.keys(node.child).some(childKey => this.hasAnyPerm(childKey));
		}
		return false;
	}


	cleanupOrphanedDefaultRedirects() {
		Object.keys(this.permissionsToAssign).forEach((resource) => {
			const perms = this.permissionsToAssign[resource];
			if (Array.isArray(perms) && perms.includes('default_redirect') && !this.hasAnyPerm(resource)) {
				this.permissionsToAssign[resource] = perms.filter(p => p !== 'default_redirect');
				if (this.permissionsToAssign[resource].length === 0) {
					delete this.permissionsToAssign[resource];
				}
			}
		});
	}

	hasChildDefaultRedirect(parentKey) {
		const parentPerm = this.permissions[parentKey];
		if (!parentPerm || !parentPerm.child) return false;
		return Object.keys(parentPerm.child).some(childKey =>
			this.hasPerm('default_redirect', childKey)
		);
	}

	getParentCategoryKey(resource) {
		if (resource.startsWith('setting-')) return 'setting';
		if (resource.startsWith('branch_mgmt_')) return 'branch_mgmt';
		if (resource.startsWith('tnt_billing_')) return 'tnt_billing';
		if (resource.startsWith('tnt_control_')) return 'tnt_control';
		if (resource.startsWith('reporting_')) return 'reporting';
		return null;
	}

	toggleDefaultRedirect(resource) {
		const isCurrentlyChecked = this.hasPerm('default_redirect', resource) || this.hasChildDefaultRedirect(resource);

		// 1. Find all resources that currently have default_redirect
		const resourcesToClear = Object.keys(this.permissionsToAssign).filter(res =>
			this.hasPerm('default_redirect', res)
		);

		// 2. Update local state synchronously immediately
		resourcesToClear.forEach(res => {
			if (Array.isArray(this.permissionsToAssign[res])) {
				this.permissionsToAssign[res] = this.permissionsToAssign[res].filter(p => p !== 'default_redirect');
				if (this.permissionsToAssign[res].length === 0) {
					delete this.permissionsToAssign[res];
				}
			}
		});

		let nextResourceToSet = null;
		if (!isCurrentlyChecked) {
			nextResourceToSet = resource;
		} else {
			// If we uncheck a child/grandchild redirect, shift it back to parent category
			const parentCategory = this.getParentCategoryKey(resource);
			if (parentCategory) {
				nextResourceToSet = parentCategory;
			}
		}

		if (nextResourceToSet) {
			if (!this.permissionsToAssign[nextResourceToSet]) {
				this.permissionsToAssign[nextResourceToSet] = [];
			}
			if (!this.permissionsToAssign[nextResourceToSet].includes('default_redirect')) {
				this.permissionsToAssign[nextResourceToSet] = [...this.permissionsToAssign[nextResourceToSet], 'default_redirect'];
			}
		}
	}


	toggleExpand(perm) {
		// this.permissions[perm].expand = !this.permissions[perm].expand
		if (perm === 'branch_mgmt_billing_approval' && this.permissions.branch_mgmt && this.permissions.branch_mgmt.child && this.permissions.branch_mgmt.child.branch_mgmt_billing_approval) {
			this.permissions.branch_mgmt.child.branch_mgmt_billing_approval.expand = !this.permissions.branch_mgmt.child.branch_mgmt_billing_approval.expand;
		}

		if(perm === 'tnt_billing_fuel_surcharges' && this.permissions.tnt_billing && this.permissions.tnt_billing.child && this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges) {
			this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges.expand = !this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges.expand;
		}

		if (this.permissions[perm]) {
			this.permissions[perm].expand = !this.permissions[perm].expand;
		}
	}

	expand(parentKey) {
		// return !!this.permissions[parentKey].expand;
		if (parentKey === 'branch_mgmt_billing_approval' && this.permissions.branch_mgmt && this.permissions.branch_mgmt.child && this.permissions.branch_mgmt.child.branch_mgmt_billing_approval) {
			return !!this.permissions.branch_mgmt.child.branch_mgmt_billing_approval.expand;
		}

		if(parentKey === 'tnt_billing_fuel_surcharges' && this.permissions.tnt_billing && this.permissions.tnt_billing.child && this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges) {
			return !!this.permissions.tnt_billing.child.tnt_billing_fuel_surcharges.expand;
		}

		if (this.permissions[parentKey]) {
			return !!this.permissions[parentKey].expand;
		}
		return false; 
	}

	isLangSelected(language) {
		return language.value == this.model.languageId;
	}

	// Reset Multi-Branch selection
	resetMultiBranchSelection() {
		if (this.model.branch && this.model.branch.length) {
			this.model.branch.forEach((selectedBranch) => {
				this.branches.filter((branch) => {
					if (branch.branchId == selectedBranch.branchId) {
						branch.ticked = false;
					}
				})
			})
		}
	}

	reset() {
		this.resetMultiBranchSelection();
		this.clearErrors();
		this.cnfPassword = '';
		this.permissionsToAssign = {};
		this.OTCKeys = {};
		this.setOtcKeys();
		this.model = angular.copy(this.defaultModel);
		this.loadSchedule(null);
	}

	resetWebUserData() {
		for (let key in this.model) {
			if (key == 'isWebUser') {
			}
			else {
				this.model["email"] = null
				this.model["password"] = null;
				this.cnfPassword = null
			}
		}
		this.undoChanges();
	}

	submit(evt) {
		// console.log(this.OTCKeys);
		if (!this.validate()) {
			return
		}

		this.loading = true

		if (!(this.model.isWebUser || this.model.customerUser)) {
			this.model.email = this.model.password = null;
		}

		let serviceZoneData = [];
		if (this.model.limitToServiceZone && this.model.selectedZones.length > 0) {
			serviceZoneData = this.model.selectedZones.map((lz) => {
				return {
					locationZoneId: lz.zoneId, userId: this.model.id
				}
			})
		}

		this.Service.create({
			id: this.model.id,
			firstName: this.model.firstName,
			lastName: this.model.lastName,
			email: this.model.email,
			supervisor: this.model.supervisor,
			languageId: this.model.languageId,
			branchId: this.model.branchId,
			password: this.model.password,
			downloadToHHT: this.model.downloadToHHT,
			// kabaKeyId: (this.model.kabaKeyId && this.model.downloadToHHT) ? this.model.kabaKeyId : null,
			// SGKeyId: (this.model.SGKeyId && this.model.downloadToHHT) ? this.model.SGKeyId : null,
			defaultAppView: (this.model.downloadToHHT || this.model.serviceUser) ? this.model.defaultAppView : null,
			hhtPassword: this.model.hhtPassword ? this.model.hhtPassword : null,
			phone: this.model.phone ? this.model.phone : null,
			// routeKeyId: (this.model.routeKeyId && this.model.downloadToHHT) ? this.model.routeKeyId : null,
			// tecnoDevId: (this.model.tecnoDevId && this.model.downloadToHHT) ? this.model.tecnoDevId : null,
			// OTCCompanyName: this.model.OTCCompanyName,
			OTCKeys: this.OTCKeys,
			serviceUser: this.model.serviceUser,
			timezone: this.model.timezone,
			customerUser: this.model.customerUser,
			customerId: this.model.customer ? this.model.customer.Value : null,
			autoCheckIn: this.enableAutoCheckInCheckOut && this.model.downloadToHHT ? this.model.autoCheckIn || false : false,
			autoCheckOut: this.enableAutoCheckInCheckOut && this.model.downloadToHHT ? this.model.autoCheckOut || false : false,
			payrollId: this.model.payrollId ? this.model.payrollId : null,
			limitToServiceZone: this.model.serviceUser ? this.model.limitToServiceZone || false : false,
			rejectTickets: (this.model.serviceUser || this.model.downloadToHHT) ? this.model.rejectTickets : false,
			selfAssignServiceTicket: this.model.serviceUser ? this.model.selfAssignServiceTicket : false,
			userAssignServiceTicket: this.model.serviceUser ? this.model.userAssignServiceTicket : false,
			addActions: this.model.serviceUser ? this.model.addActions : false,
			createTickets: this.model.serviceUser ? this.model.createTickets : false,
			serviceZoneData,
			shipmentTransfer: this.model.shipmentTransfer || false,
			branchCounterId: this.model.isWebUser ? this.model.branchCounterId : null,
			serviceLevel: this.model.serviceUser ? this.model.serviceLevel : null,
			userOrigin: this.model.serviceUser ? this.model.userOrigin : null,
			address: this.model.address || null,
			city: this.model.city || null,
			state: this.model.state || null,
			zip: this.model.zip || null,
			country: this.model.isNonUSLocation ? this.model.country : (this.model.address ? 'US' : null),
			lat: this.model.lat || null,
			long: this.model.long || null,
			make: this.model.serviceUser ? this.parseMakeValues(this.model.make) : [],
			schedule: (this.model.downloadToHHT || this.model.serviceUser || this.model.isWebUser) ? this.formatScheduleForSave() : null
		})
			.then((data) => {
				this.loading = false
				if (data['id']) {
					let id = data['id']
					let branchId = data['branchId'];
					const resources = Object.keys(this.permissionsToAssign);
					if (this.model.branch.length && this.model.sameForAll) {
						const branchIds = this.model.branch.map(b => b.id)
						let defer = this.$q.defer();
						this.createUserPermission(resources, branchIds, id)
							.then((res) => {
								defer.resolve()
							})
							.catch((err) => {
								defer.reject(err)
							})
						return defer.promise;
						// })
						// return this.$q.all(promise)
					} else {
						return this.createUserPermission(resources, [branchId], id)
					}
				}
			})
			.then((res) => {
				this.addMultipleBranchs();
				this.createUserFundingSourceGroup();
				this.askCreate();
			})
			.catch((err) => {
				this.loading = false;
				if (err && err.data && err.data.message) {
					this.errorMessage += err.data.message + '<br/>'
				}
				else if (err.data.errors && err.data.errors[0].path == 'PRIMARY') {
					this.errorMessage = this.$translate.instant('users.userId_error');
				}
				else {
					err.data.errors.map((e) => {
						this.errorMessage += e.message + '<br/>'
					})
				}
			})
	}

	undoChanges() { // undo user permissions if not webUser
		if (!this.model.isWebUser) {
			this.permissionsToAssign = {};
			this.model.sameForAll = false;
			this.model.branchPermission = null;
		}
	}

	createUserPermission(resources, branchIds, userId) {
		return new Promise((resolve, reject) => {
			this.UserService.addRole(userId, branchIds)
				.then((data) => {
					this.$q.all(
						resources.map((resource) => {
							const obj = {
								role: 'user:' + userId, //this role is dependent on role passed in UserService.addRole()
								resource: resource,
								permission: this.permissionsToAssign[resource],
								user: userId,
								branchIds: branchIds
							};
							return this.UserService.updateAcl(obj, true);
						})
					)
						.then(resolve)
						.catch(reject);
				})
				.catch((err) => {
					console.log(err);
					reject(err);
				});
		});
	}

	// reset value of kabaKeyId & SGKeyId
	resetKeyId() {
		if (!this.model.downloadToHHT) {
			// this.model.kabaKeyId = null;
			// this.model.SGKeyId = null;
			// this.model.routeKeyId = null;
			// this.model.tecnoDevId = null;
			this.model.make = [];
			this.loadAtmMakes();
			this.OTCKeys = {};
			this.setOtcKeys();
			this.model.OTCCompanyName = null;
			this.model.autoCheckIn = false;
			this.model.autoCheckOut = false;
			this.isDisabledSupervisor = false;
		}
	}

	//  add multiple branch
	addMultipleBranchs() {
		const branches = this.model.branch.map((b) => b.id)
		return new Promise((resolve, reject) => {
			this.UserService.createBranchGrouped({ userId: this.model.id, branches: branches })
				.then(() => {
					resolve();
				})
				.catch((err) => {
					reject(err);
				});
		})
	}

	autoSelectSameForAll() {
		// this.$scope.$watch(() => {
		// 	return this.model.branch
		// }, (branches) => {
		// 	if (branches.length > 1) return this.model.sameForAll = true;
		// 	else return this.model.sameForAll = false;
		// })
		if (this.model.branch.length > 1) return this.model.sameForAll = true;
		else return this.model.sameForAll = false;
	}

	removeSelection() {
		this.model.sameForAll = false;
	}

	loadServiceZone() {
		setTimeout(() => {
			const selectedBranch = Array.isArray(this.model.branch) ? this.model.branch.map((branch) => branch.id) : [];
			const searchObj = {
				queryJSON: {
					rules: [{ field: 'branchId', condition: 'IN', data: selectedBranch }],
					operator: 'AND'
				}
			};
			const selectedIds = (this.model.selectedZones || []).map((zone) => zone.zoneId);
			this.LocationZoneService.all(searchObj, 0, 1000)
				.then((data) => {
					this.serviceZoneData = this.serviceZoneMap(data.results || [], selectedIds);
					this.model.selectedZones = this.serviceZoneData.filter((zone) => zone && zone.zoneId != null && zone.ticked);
				});
		});
	}

	serviceZoneMap(records, preserve) {
		const DAY_ORDER = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY', 'HOLIDAY'];
		const byBranch = _.groupBy(records || [], 'branchId');

		const grouped = [];
		Object.keys(byBranch).sort().forEach((branchId) => {
			grouped.push({ label: `<strong>${branchId}</strong>`, msGroup: true });
			const byDay = _.groupBy(byBranch[branchId], 'dayOfWeek');
			DAY_ORDER.filter((d) => byDay[d]).forEach((day) => {
				grouped.push({ label: `<strong>${day}</strong>`, msGroup: true });
				byDay[day].forEach((z) => {
					const info = z.id + ' | ' + z.name + ' (' + z.branchId + ', ' + z.dayOfWeek + ')';
					grouped.push({
						zoneName: z.name, zoneId: z.id, zoneInfo: info,
						label: z.id + ' | ' + z.name, ticked: preserve.includes(z.id)
					});
				});
				grouped.push({ msGroup: false });
			});
			grouped.push({ msGroup: false });
		});
		return grouped;
	}

	setOtcKeys() {
		this.company = this.CommonLayoutService.setOTCKeys(this.OTCCompanies).company;
		this.OTCKeys = this.CommonLayoutService.setOTCKeys(this.OTCCompanies).OTCKeys;
	}

	OTCCompanyMap() {
		this.OTCCompanyNameList = this.CommonLayoutService.OTCCompanyMapping(this.OTCCompanies);
	}

	// setPermissionBranch() {
	// 	this.model.branchPermission = this.model.branchId;
	// }

	getFundingSource() {
		setTimeout(() => {
			let selectedBranch = Array.isArray(this.model.branch) ? this.model.branch.map((branch) => branch.id) : this.model.branch.split();

			const searchObj = {
				queryJSON: {
					rules: [{
						field: 'branchId',
						condition: 'IN',
						data: selectedBranch
					},
					],
					operator: 'AND'
				}
			};

			this.loadFundingSource = true;
			this.BranchFundingSourceService.all(searchObj, 0, 1000, null)
				.then((data) => {
					this.branchFundingSourceData = data.results;
					this.branchFundingSourceGrouped = [];
					let grouped = _.groupBy(this.branchFundingSourceData, 'branchId')
					let keys = Object.keys(grouped);
					let indexMap2 = {};
					const indexMap = {}, addHeader = {};

					keys.forEach(k => {
						delete indexMap2[k];
						grouped[k].forEach(g => {
							if (!addHeader.hasOwnProperty('header')) {
								addHeader['header'] = true;
								this.branchFundingSourceGrouped.push(
									{
										label: '<strong>All Branch Funding Source</strong>',
										msGroup: true
									})
							}
							if (!indexMap.hasOwnProperty(g.branchId)) {
								indexMap[g.branchId] = grouped[k].length;
								this.branchFundingSourceGrouped.push(
									{
										label: `<strong>${k}</strong>`,
										msGroup: true
									},
								)
							}
							this.branchFundingSourceGrouped.push(
								{
									name: g.sourceName,
									branch: g.branchId,
									fundingSourceId: g.id,
									label: g.sourceName + ' | ' + '(' + g.locationId + ')',
									ticked: false
								},
							)
						})
						if (!indexMap2.hasOwnProperty(k)) {
							indexMap2[k] = 0;
							this.branchFundingSourceGrouped.push(
								{
									msGroup: false
								})
						}
					})
					this.branchFundingSourceGrouped.push({ msGroup: false });
				})
				.catch((err) => {
					console.log(err);
				})
				.finally(() => {
					this.loadFundingSource = false;
				})
		})
	}

	isServiceOnlyUser() {
		return this.model.serviceUser && !this.model.isWebUser && !this.model.supervisor && !this.model.downloadToHHT;
	}

	createUserFundingSourceGroup() {
		const fundingSource = this.isServiceOnlyUser() ? [] : (this.selectedFundingSource || []);
		return this.UserBranchFundingSourceService.createUserFundingSourceGroup(this.model.id, fundingSource)
			.then(() => void undefined)
			.catch((err) => {
				console.log(err);
			});
	}

	setCustomerUser(flag) { 
		if (flag && this.model.customerUser) {
			this.model.serviceUser = false; 
			this.model.supervisor = false; 
			this.model.downloadToHHT= false; 
			this.model.isWebUser = false;
			this.selectedFundingSource = [];
			this.removeAssignPermissions()
		} else if (!flag && (this.model.serviceUser || this.model.supervisor || this.model.downloadToHHT || this.model.isWebUser)) {
			this.model.customerUser = false;
			this.model.customer = '';
		} else if (!this.model.isWebUser && !this.model.customerUser) {
			this.removeAssignPermissions()
		}
	}
	removeAssignPermissions() {
		if (!this.model.isWebUser) {
			let parentAssignKeys = Object.keys(this.permissionsToAssign);
			if (parentAssignKeys && parentAssignKeys.length) {
				parentAssignKeys.map(key => {
					if (this.model.customerUser && (0 > this.customerPermissions.indexOf(key))) {
						delete this.permissionsToAssign[key]
					} else if (!this.model.customerUser && !this.model.isWebUser) {
						delete this.permissionsToAssign[key]
					}
				})
			}
		}
	}
	hasActiveAncestors(resource) {
		if (this.permissions[resource]) {
			return true;
		}

		let parentKey = null;
		for (const [topKey, topVal] of Object.entries(this.permissions)) {
			if (topVal.child && topVal.child[resource]) {
				parentKey = topKey;
				break;
			}
			if (topVal.child) {
				for (const [childKey, childVal] of Object.entries(topVal.child)) {
					if (childVal.child && childVal.child[resource]) {
						parentKey = childKey;
						break;
					}
				}
				if (parentKey) break;
			}
		}

		if (!parentKey) return true;

		if (!this.hasAnyPerm(parentKey)) {
			return false;
		}

		return this.hasActiveAncestors(parentKey);
	}

	disabledPermissions(parent, child) {
		if (parent == 'branch_mgmt_restore_route_assignments') {
			return true;
		}
		
		if (this.model.customerUser) {
			if (child) {
				// if (child == 'create' && parent == 'service_tickets') {
				// 	return true;
				// }
				if (parent == 'setting-location' && ['create', 'importLocations', 'clone', 'editCustomer'].indexOf(child) >= 0 ) return true;
				if (parent == 'bulk_cash_management' && child !== 'view' && child !== 'export') return true;
			}
			return (0 > this.customerPermissions.indexOf(parent))
		} else if (this.model.isWebUser) {
			return false
		} else {
			return true
		}
	}

	customerSearchPaginate(searchKey, idKey, nameKey) {
		return {
			queryJSON: {
				rules: [{
					field: idKey,
					condition: 'like',
					data: '%' + searchKey + '%'
				},
				{
					field: nameKey,
					condition: 'like',
					data: '%' + searchKey + '%'
				}
				],
				operator: 'OR'
			}
		}
	}

	getCustomer(searchKey, offset) {
		searchKey = searchKey || '';
		let costomerSearchObj = this.customerSearchPaginate(searchKey, 'id', 'name')
		if (offset !== 0 && !searchKey && Math.abs(offset % 2) == 1) {
			offset = offset - 1;
		}
		this.CustomerService.all(costomerSearchObj, offset, AppConstants.defaultPageLimit)
			.then((res) => {
				if (offset === 0 || offset == undefined) {
					this.totalCustomer = res.total;
					this.customerList =  _.uniqBy(this.mappingCustomerDatas(res.results), 'Value');
				} else {
					const customers = this.mappingCustomerDatas(res.results);
					this.customerList = _.uniqBy(this.customerList.concat(customers), 'Value');
				}
			})
			.catch((err) => {
				if (err && err.data && err.data.message) {
					this.errorMessage = err.data.message;
				}
			})
	}

	mappingCustomerDatas(customers) {
		return customers.map((customer) => {
			const customerObj = {
				Key: customer.id + ' | ' + customer.name,
				Value: customer.id
			};

			return customerObj;
		});
	}

	validateAutoChekInChekOut() {
		if (!this.model.branchId) return;
		const selectedBranch = _.find(this.allSetup, { branchId: this.model.branchId });
		this.enableAutoCheckInCheckOut = selectedBranch.enableAutoCheckInCheckOut;
	}

	forceSupervisorToSetOn() {
		if (this.model.downloadToHHT && (this.model.autoCheckIn || this.model.autoCheckOut)) {
			this.isDisabledSupervisor = true;
			this.model.supervisor = true;
		}
		else {
			// this.model.supervisor = false;
			this.isDisabledSupervisor = false;
		}
	}

	resetServiceZone() {
		if ((!this.model.serviceUser || !this.model.limitToServiceZone)) {
			if (!this.model.serviceUser) {
				this.model.limitToServiceZone = false;
			}
			setTimeout(() => {
				this.model.selectedZones = [];
				this.serviceZoneData.forEach(zone => {
					zone.ticked = false;
				});
			})
		}
	}

	clearFundingSourceIfServiceOnly() {
		if (this.isServiceOnlyUser()) {
			this.selectedFundingSource = [];
			(this.branchFundingSourceGrouped || []).forEach((bfs) => {
				bfs.ticked = false;
			});
		}
	}
	parseMakeValues(makeValue) {
		if (Array.isArray(makeValue)) {
			return makeValue
				.map((item) => {
					if (!item) return null;
					if (typeof item === 'string') {
						const vendorName = item.trim();
						return vendorName ? { atmMakeId: null, vendorName } : null;
					}
					const vendorName = (item.vendorName || item.Value || item.value || item.Key || item.label || '').trim();
					const atmMakeId = item.atmMakeId || item.id || (item.atmMake && item.atmMake.id) || null;
					return vendorName ? { atmMakeId, vendorName } : null;
				})
				.filter(Boolean);
		}

		if (!makeValue) return [];

		return String(makeValue)
			.split(',')
			.map((item) => item.trim())
			.filter(Boolean)
			.map((vendorName) => ({ atmMakeId: null, vendorName }));
	}

	serializeMakeValues(makeValue) {
		const values = this.parseMakeValues(makeValue);
		return values.length ? values.map((item) => item.vendorName).join(', ') : null;
	}

	buildAtmMakeOptions(results, selectedMakes) {
		const selectedValues = this.parseMakeValues(selectedMakes);
		const selectedById = selectedValues.map((item) => item.atmMakeId).filter(Boolean);
		const selectedByName = selectedValues.map((item) => item.vendorName).filter(Boolean);
		const options = (results || [])
			.filter((item) => item.active)
			.map((item) => ({
				Key: item.vendorName,
				Value: item.vendorName,
				id: item.id,
				atmMakeId: item.id,
				vendorName: item.vendorName,
				ticked: selectedById.includes(item.id) || selectedByName.includes(item.vendorName)
			}));

		selectedValues.forEach((selectedItem) => {
			if (options.findIndex((item) => item.atmMakeId === selectedItem.atmMakeId || item.Value === selectedItem.vendorName) === -1) {
				options.push({
					Key: selectedItem.vendorName,
					Value: selectedItem.vendorName,
					id: selectedItem.atmMakeId || selectedItem.vendorName,
					atmMakeId: selectedItem.atmMakeId,
					vendorName: selectedItem.vendorName,
					ticked: true
				});
			}
		});

		return options;
	}

	loadAtmMakes(selectedMakes = this.model.make) {
		return this.AtmMakesService.all('', 0, 1000)
			.then(({ results }) => {
				this.atmMakesList = this.buildAtmMakeOptions(results, selectedMakes);
				this.model.make = this.parseMakeValues(selectedMakes);
			})
			.catch((err) => {
				console.log(err);
				this.atmMakesList = [];
				this.model.make = [];
			});
	}

	loadSchedule(schedule) {
		this.model.schedule = {};
		this.scheduleErrors = {};
		if (schedule) {
			this.scheduleDays.forEach(day => {
				this.model.schedule[day.startKey] = this.parseTimeString(schedule[day.startKey]) || null;
				this.model.schedule[day.endKey] = this.parseTimeString(schedule[day.endKey]) || null;
				day.active = !!schedule[day.startKey];
			});
		} else {
			this.scheduleDays.forEach(day => {
				this.model.schedule[day.startKey] = null;
				this.model.schedule[day.endKey] = null;
				day.active = false;
			});
		}
	}

	toggleScheduleDay(day) {
		day.active = !day.active;
		if (!day.active) {
			this.model.schedule[day.startKey] = null;
			this.model.schedule[day.endKey] = null;
			delete this.scheduleErrors[day.key + 'Order'];
		}
		this.validateScheduleDay(day);
	}

	validateScheduleDay(day) {
		delete this.scheduleErrors[day.key + 'Order'];

		if (day.active) {
			if (this.model.schedule[day.startKey] && this.model.schedule[day.endKey]) {
				const start = this.formatTimeOnly(this.model.schedule[day.startKey]);
				const end = this.formatTimeOnly(this.model.schedule[day.endKey]);
				if (start && end && start >= end) {
					this.scheduleErrors[day.key + 'Order'] = true;
				}
			}
		}
	}

	hasScheduleErrors() {
		return Object.keys(this.scheduleErrors).length > 0;
	}

	formatScheduleForSave() {
		const schedule = {};
		this.scheduleDays.forEach(day => {
			schedule[day.startKey] = this.formatTimeOnly(this.model.schedule[day.startKey]);
			schedule[day.endKey] = this.formatTimeOnly(this.model.schedule[day.endKey]);
		});
		return schedule;
	}

	formatTimeOnly(val) {
		if (!val) return null;
		if (typeof val === 'string' && /^\d{2}:\d{2}(:\d{2})?$/.test(val)) return val;
		const d = new Date(val);
		if (isNaN(d.getTime())) return null;
		const h = String(d.getHours()).padStart(2, '0');
		const m = String(d.getMinutes()).padStart(2, '0');
		return h + ':' + m;
	}

	parseTimeString(timeString) {
		if (!timeString) return null;
		const [hours, minutes] = timeString.split(':');
		const d = new Date();
		d.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);
		return d;
	}

	getBranchCounters(){
		if(this.model.branchId){
    return this.UserService.getBranchCounters(this.model.branchId)
		.then((data) => {
			const counters = data.branchCounters || [];
			this.countStationList = counters.map(cs => ({
				label: cs.name || cs.label || cs.id, 
				value: cs.id
			}));
		})
	}
}
}

export default UsersCreateController;



// WEBPACK FOOTER //
// ./client/app/components/users/create/users.create.controller.js